import React, { Component } from "react";
import { getDateData } from "../common/HelperFunctions";
import icon from "../assets/list-icon.svg";
import API from "../common/Api";

function numberWithCommas(x, zeros = 2) {
  x = Number(x);
  if (isNaN(zeros) || zeros < 0) {
    zeros = 2;
  }
  let parts = x.toFixed(zeros).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

export default class GroupBookingDetails extends Component {
  sumServicesPrice = (services) => {
    if (!services || !Array.isArray(services)) return 0;
    return services.reduce((total, service) => total + (Number(service.price) || 0), 0);
  };

  handleDownloadCSV = () => {
    const { booking, headers } = this.props;

    const service = booking.services?.[0];
    // Format date to Y-m-d in local timezone
    const date = new Date(booking.date);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const params = new URLSearchParams({
      date: formattedDate,
      start_time: booking.start_time,
      service_id: service?.id,
      team_member_id: booking.transaction?.team_member?.id
    });

    API.get(`business/appointments/guest-list?${params.toString()}`, {
      ...headers,
      responseType: 'blob'
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `group-booking-${booking.identifier}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Failed to download guest list:', error);
        window.$.notify('Failed to download guest list', 'error');
      });
  };



  render() {
    const { booking, groupData, groupBookings, showClientContact, isOwner } = this.props;

    // Use data from route state if available, otherwise fall back to booking data
    const total_participants = groupData?.total_participants || booking?.total_participants || 0;
    const maxCapacity = groupData?.max_capacity || booking?.max_capacity || booking?.services?.[0]?.max_capacity || 0;
    const capacityPercentage = maxCapacity > 0 ? (total_participants / maxCapacity) * 100 : 0;
    const serviceName = groupData?.service_name || booking?.service_name || booking?.services?.[0]?.name || '';
    const handlesProcessingFee = groupData?.handles_processing_fee || booking?.handles_processing_fee || booking?.transaction?.meta?.booking_settings?.handles_processing_fee;

    // Aggregated totals
    const totalAmountPaid = groupData?.total_amount_paid || booking?.total_amount_paid || 0;
    const totalRizevoCommission = groupData?.total_rizevo_commission || booking?.total_rizevo_commission || 0;
    const totalDiscountAmount = groupData?.total_discount_amount || booking?.total_discount_amount || 0;
    const totalPriorityBooking = groupData?.total_priority_booking || booking?.total_priority_booking || 0;
    const totalBalanceAmount = groupData?.total_balance_amount || booking?.total_balance_amount || 0;
    const upfrontPercentage = groupData?.upfront_percentage_payment || booking?.upfront_percentage_payment || 100;

    // Calculate upfront payment
    let upfrontPayment = totalAmountPaid;
    if (handlesProcessingFee !== 'business') {
      upfrontPayment -= (totalPriorityBooking + totalRizevoCommission);
    } else {
      upfrontPayment -= totalPriorityBooking;
    }
    upfrontPayment += totalDiscountAmount;

    return (
      <>
        {/* Group Session Header */}
        <div className="card-section group-header-section">
          <div className="group-booking-header">
            <span className="service-name">{serviceName}</span>
            <span className="group-badge">GROUP</span>
          </div>
          <div className="group-booking-info">
            <span className="group-list">
              <img src={icon} alt="" />
              <p>₦{numberWithCommas(booking.services?.[0]?.price || 0, 0)} per person</p>
            </span>
            <span className="group-list">
              <img src={icon} alt="" />
              <p>{booking.team_member?.first_name}</p>
            </span>
          </div>
        </div>

        {/* Date & Capacity */}
        <div className="card-section">
          <div className="info">
            <div className="hundred-percent-width">
              <p className="date thick">
                {getDateData(booking.date, true, true)}
              </p>
              <p className="time">
                ({booking.start_time} - {booking.end_time})
              </p>
              <div className="group-capacity-section">
                <span className="capacity-text">{total_participants} of {maxCapacity}</span>
                <div className="group-booking-capacity">
                  <div className="capacity-progress-bar">
                    <div
                      className="capacity-progress-fill"
                      style={{ width: `${capacityPercentage}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

              {/* Payment Summary */}
        <div className="card-section">
          <div className="details">
            <p className="flex space-btw">
              <span className="detail cash" style={{ fontWeight: '800' }}>Total amount paid</span>
              <span className="cash" style={{ fontWeight: '700' }}>₦{numberWithCommas(totalAmountPaid, 0)}</span>
            </p>
            <hr />

            <p className="flex space-btw">
              <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>
                - Upfront Payment ({upfrontPercentage}%)
              </span>
              <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                ₦{numberWithCommas(Math.max(upfrontPayment, 0), 0)}
              </span>
            </p>

            {totalDiscountAmount > 0 && (
              <p className="flex space-btw">
                <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>- Discount</span>
                <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  -₦{numberWithCommas(totalDiscountAmount, 0)}
                </span>
              </p>
            )}

            {handlesProcessingFee !== 'business' && totalRizevoCommission > 0 && (
              <p className="flex space-btw">
                <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>- Processing fee</span>
                <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  ₦{numberWithCommas(totalRizevoCommission, 0)}
                </span>
              </p>
            )}

            {totalPriorityBooking > 0 && (
              <p className="flex space-btw">
                <span className="detail" style={{ color: '#5D6C76', fontWeight: '600' }}>- Priority Booking</span>
                <span className="cash" style={{ color: '#5D6C76', fontWeight: '600' }}>
                  ₦{numberWithCommas(totalPriorityBooking, 0)}
                </span>
              </p>
            )}

            <p className="flex space-btw">
              <span className="detail cash" style={{ fontWeight: '800' }}>Balance</span>
              <span className="cash" style={{ fontWeight: '800' }}>₦{numberWithCommas(totalBalanceAmount, 0)}</span>
            </p>
          </div>
        </div>

        {/* Customers & Guests List */}
        {groupBookings.length > 0 && (
          <div className="card-section customers-section">
            <div className="customers-section-header">
              <h4>Customers & Guests</h4>
              {isOwner && (
                <span className="download-list-link" onClick={this.handleDownloadCSV}>
                  Download list
                </span>
              )}
            </div>
            {groupBookings.map((gb, index) => {
              const guestCount = gb.guests?.length || 0;
              const quantity = gb.quantity || 1;
              return (
                <div key={index} className="customer-booking-item">
                  <div className="customer-booking-row">
                    <span className="customer-name-guests">
                      <span className="main-guest-name">{gb.name}</span>
                      {guestCount > 0 && ` +${guestCount} guest${guestCount > 1 ? 's' : ''}`}
                    </span>
                    <span className="customer-amount">₦{numberWithCommas(gb.amount_paid || 0, 0)}</span>
                  </div>
                  {showClientContact && (
                    <>
                      <p className="customer-contact">
                        - Phone: <a href={`tel:${gb.phone}`} className="co-pink">{gb.phone}</a>
                      </p>
                      <p className="customer-contact">
                        - Email: <a href={`mailto:${gb.email}`} className="co-pink">{gb.email}</a>
                      </p>
                    </>
                  )}
                  {gb.booking_notes && (
                    <p className="customer-contact">
                      - Customer Notes: {gb.booking_notes}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  }
}
